import http_config from '../../common/config/http_config';
import axiosInstance from '../../common/helper/axiosInterceptor';
import { AlertNoticeModel } from './alert.model';

export const onSetAlertNotice = (payload: AlertNoticeModel): Promise<AlertNoticeModel> => {
  return axiosInstance.post(http_config.BASE_URL + '/alert', payload);
};
